import convertPropertiesDeep from '@dyl/utils/convertPropertiesDeep';
import { cloneDeep } from 'lodash';

export default function convertToLocalFormat(task) {
    task = cloneDeep(task);

    // Convert nested remote objects to IDs (which is the form for upload too)
    convertPropertiesDeep(task, /rubric(?!_id)/, p => `${p}_id`, r => r?.rubric_id ?? null);
    // 'context_audio' is an exception, as it's always an id -- Not the case anymore.
    convertPropertiesDeep(task, /(.*)audio(?!_id)/, p => `${p}_id`, a => a?.audio_id ?? null);

    if (task.task_type_id === 'picture_editing') {
        for (let i = 0; i < task.items.length; i++) {
            task.items[i].answers = task.items[i].answers.sort((x, y) => y.is_correct_answer - x.is_correct_answer);
        }
    }
    return task;
}